export function relativeTime(input: string | number | Date): string {
  const t = typeof input === "string" || typeof input === "number" ? new Date(input) : input;
  const diff = Date.now() - t.getTime();
  if (Number.isNaN(diff)) return "—";
  const abs = Math.abs(diff);
  const sec = Math.floor(abs / 1000);
  if (sec < 5) return "just now";
  if (sec < 60) return `${sec}s ago`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const days = Math.floor(hr / 24);
  if (days < 7) return `${days}d ago`;
  const weeks = Math.floor(days / 7);
  if (weeks < 4) return `${weeks}w ago`;
  return t.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function shortTime(input: string | Date): string {
  const t = typeof input === "string" ? new Date(input) : input;
  if (Number.isNaN(t.getTime())) return "—";
  return t.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

export function isoDate(input: string | Date): string {
  const t = typeof input === "string" ? new Date(input) : input;
  if (Number.isNaN(t.getTime())) return "—";
  return t.toISOString().slice(0, 16).replace("T", " ");
}

/** Humanized absolute date+time in the VIEWER's locale + timezone
 *  (e.g. "Jun 6, 3:45 PM"). Use where a relative time is too vague. */
export function localDateTime(input: string | Date): string {
  const t = typeof input === "string" ? new Date(input) : input;
  if (Number.isNaN(t.getTime())) return "—";
  return t.toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
}

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  const kb = n / 1024;
  if (kb < 1024) return `${kb.toFixed(1)} KB`;
  const mb = kb / 1024;
  if (mb < 1024) return `${mb.toFixed(1)} MB`;
  return `${(mb / 1024).toFixed(2)} GB`;
}

export function formatDuration(ms: number): string {
  if (ms < 1000) return `${ms}ms`;
  const sec = Math.floor(ms / 1000);
  if (sec < 60) return `${sec}s`;
  const min = Math.floor(sec / 60);
  const rem = sec % 60;
  if (min < 60) return `${min}m ${rem}s`;
  const hr = Math.floor(min / 60);
  return `${hr}h ${min % 60}m`;
}

export function pluralize(n: number, word: string, plural?: string): string {
  return `${n} ${n === 1 ? word : plural ?? word + "s"}`;
}
